import React, { Component } from 'react'
import EditSearch from './Edit'

export default class DuplicateSearch extends Component {
  render() {
    return (
      <EditSearch duplicate {...this.props} />
    )
  }
}



// WEBPACK FOOTER //
// client/components/sections/website/SearchLibrary/Duplicate.js